module.exports = __webpack_public_path__ + "images/application/b-search-2bdc62b2.svg";